/* AIVIQ product page: the chapters below the top section (sections/aiviq-pdp-chapters.liquid).
   - Question rows (.hrow): open and close, starting as on the canvas (minus = open, plus = closed).
   - In-page links: open a closed drop-down on the way; hide links whose target is not on the page (yet).
   - »Tilføj til kurv« in a chapter presses the page's own buy form (the cart drawer opens as usual). */
(function () {
  const root = document.querySelector('[data-apc]');
  if (!root || root.dataset.apcReady) return;
  root.dataset.apcReady = '1';

  /* 1200–1439 px: a page whose computer layout has fixed column widths (drawn for 1440 px) is scaled down to fit */
  const fit = () => {
    root.style.removeProperty('--apc-zoom');
    const w = window.innerWidth;
    if (w < 1200 || w >= 1440) return;
    const over = [...root.querySelectorAll('section')].some((s) => s.scrollWidth > s.clientWidth + 2);
    if (over) root.style.setProperty('--apc-zoom', (w / 1440).toFixed(4));
  };
  fit();
  window.addEventListener('resize', fit);

  /* A comparison grid with a card left out (a product that is not in the shop yet) closes the empty column:
     the grid goes back to the board's layout by itself when the product is published. */
  root.querySelectorAll('.mc-g:not(.am)').forEach((g) => {
    const cards = g.querySelectorAll(':scope > .mc').length;
    const kids = [...g.children].filter((c) => getComputedStyle(c).display !== 'none').length;
    const cols = getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length;
    if (window.innerWidth >= 1200 && cards >= 2 && cards === kids - 1 && kids < cols) g.style.gridTemplateColumns = `repeat(${kids}, minmax(0, 1fr))`;
  });

  /* »+ Tilføj« (data-apc-buy = variant ids): puts the adapter(s) in the cart; the cart drawer opens as usual */
  const addUrl = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
  root.querySelectorAll('[data-apc-buy]').forEach((btn) => {
    const ids = btn.getAttribute('data-apc-buy').split(',').map((s) => s.trim()).filter(Boolean);
    if (!ids.length) { btn.hidden = true; return; }
    btn.addEventListener('click', async () => {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
        });
        const data = await res.json();
        if (!res.ok) throw data;
        btn.setAttribute('aria-pressed', 'true');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: btn } }));
      } catch (x) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', { bubbles: true, detail: { errorMessage: x && x.description } }));
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  });

  /* Rows the boards draw as a cut-off slider (a clipped box around one wider row): they swipe on the website */
  const swipe = () => {
    root.querySelectorAll('div').forEach((box) => {
      if (box.classList.contains('apc-swipe') || !box.offsetParent || box.children.length !== 1) return;
      const row = box.firstElementChild;
      if (box.clientWidth < 100 || box.scrollWidth <= box.clientWidth + 40 || row.children.length < 2) return;
      if (getComputedStyle(box).overflowX !== 'hidden' || !/flex|grid/.test(getComputedStyle(row).display)) return;
      box.classList.add('apc-swipe');
      box.setAttribute('tabindex', '0');
    });
  };
  swipe();
  window.addEventListener('resize', swipe);

  /* The comparison on phones (»Sammenlign med«): the board draws one pair. The buttons now switch the model:
     picture, name, price, link, the rows that differ and the »Ens på begge« line come from the computer cards,
     so prices stay live and a product that is not in the shop has no button. */
  root.querySelectorAll('section').forEach((sec) => {
    const chipsBox = sec.querySelector('fieldset .chips');
    const pair = sec.querySelector('.fam-pair');
    const cards = [...sec.querySelectorAll('.mc-g > .mc')];
    if (!chipsBox || !pair || cards.length < 2) return;
    const txt = (el) => (el ? el.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim() : '');
    const data = cards.map((c) => ({
      el: c,
      name: txt(c.querySelector('.h p')),
      price: c.querySelector('.h .now') ? c.querySelector('.h .now').innerHTML : '',
      img: c.querySelector('img'),
      link: c.querySelector('.f a'),
      rows: [...c.querySelectorAll('dl .r')].map((r) => [txt(r.querySelector('dt')), r.querySelector('dd') ? r.querySelector('dd').innerHTML : '–']),
    }));
    const me = data.find((d) => d.el.classList.contains('pick')) || data.find((d) => !d.link) || data[0];
    const head = chipsBox.closest('fieldset').nextElementSibling;
    const col = head && head.firstElementChild;                       /* the other model's column */
    const same = [...sec.querySelectorAll('span.am')].find((s) => /^Lika på båda/.test(txt(s)));
    const rowsBox = pair;
    const labels = pair.querySelector('.asp-cn');
    const tplFirst = pair.children[1];
    const tplNext = pair.children[2] || tplFirst;
    if (!col || !tplFirst) return;
    const chips = [...chipsBox.querySelectorAll('button')];
    const check = chipsBox.querySelector('svg');
    const match = (chip) => { const t = txt(chip); return data.find((d) => d !== me && (d.name === t || d.name.indexOf(t + ' ') === 0 || d.name.indexOf(t) === 0)); };
    const show = (chip) => {
      const d = match(chip);
      if (!d) return;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      if (check) chip.insertBefore(check, chip.firstChild);
      const img = col.querySelector('img');
      if (img && d.img) { img.src = d.img.currentSrc || d.img.src; img.removeAttribute('srcset'); if (d.img.getAttribute('srcset')) img.setAttribute('srcset', d.img.getAttribute('srcset')); img.alt = d.img.alt; }
      const ps = col.querySelectorAll(':scope > p');
      if (ps[0]) ps[0].textContent = d.name;
      if (ps[1]) ps[1].innerHTML = d.price;
      const a = col.querySelector('a');
      if (a && d.link) { a.href = d.link.getAttribute('href'); a.innerHTML = d.link.innerHTML; }
      if (labels && labels.firstElementChild) labels.firstElementChild.textContent = txt(chip);
      const eq = [];
      const diff = [];
      d.rows.forEach(([label, val]) => {
        const mine = (me.rows.find((r) => r[0] === label) || [label, '–'])[1];
        if (mine.replace(/\s+/g, ' ') === val.replace(/\s+/g, ' ')) eq.push(label); else diff.push([label, val, mine]);
      });
      [...rowsBox.children].slice(1).forEach((r) => r.remove());
      diff.forEach(([label, val, mine], i) => {
        const row = (i === 0 ? tplFirst : tplNext).cloneNode(true);
        const p = row.querySelector('p');
        const cell = row.querySelector('div');
        if (p) { const dot = p.querySelector('span'); p.textContent = label; if (dot) p.insertBefore(dot, p.firstChild); }
        if (cell && cell.children.length >= 2) { cell.children[0].innerHTML = val; cell.children[1].innerHTML = mine; }
        rowsBox.appendChild(row);
      });
      if (same) { same.textContent = eq.length ? 'Lika på båda: ' + eq.join(', ') : ''; }
    };
    chips.forEach((chip) => {
      if (!match(chip)) { chip.hidden = true; return; }               /* not in the shop: no button */
      chip.addEventListener('click', () => show(chip));
    });
  });

  /* A film poster (the picture's text starts with »Film:«, or it names a YouTube film in data-film-url): the whole
     poster plays the film in a player over the page; ✕, Esc or a click outside closes it. The film is the YouTube
     film named on the picture, else the product's own film from the gallery (data-film on the wrapper).
     Nothing is loaded before the tap (YouTube through its no-cookie address). */
  let player = null;
  let playerBack = null;
  const closeFilm = () => {
    if (!player) return;
    const v = player.querySelector('video');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    player.remove();
    player = null;
    document.documentElement.classList.remove('apc-film-open');
    if (playerBack && document.contains(playerBack)) playerBack.focus({ preventScroll: true });
  };
  const openFilm = (from, label, src, yt, poster) => {
    closeFilm();
    playerBack = from;
    player = document.createElement('div');
    player.className = 'apc-film';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-label', label);
    const x = document.createElement('button');
    x.type = 'button';
    x.className = 'apc-film__x';
    x.setAttribute('aria-label', 'Stäng filmen');
    x.textContent = '✕';
    let media;
    if (yt) {
      media = document.createElement('iframe');
      media.src = 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&playsinline=1';
      media.title = label;
      media.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      media.allowFullscreen = true;
    } else {
      media = document.createElement('video');
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.preload = 'metadata';
      media.src = src;
      /* the lighter 720p file is missing for a few films: fall back to the file the shop names */
      const hd = root.getAttribute('data-film-hd') || '';
      if (hd && hd !== src) media.addEventListener('error', () => { media.src = hd; media.play().catch(() => {}); }, { once: true });
      if (poster) media.poster = poster;
    }
    player.append(x, media);
    player.addEventListener('click', (ev) => { if (ev.target === player || ev.target === x) closeFilm(); });
    document.body.appendChild(player);
    document.documentElement.classList.add('apc-film-open');
    x.focus();
  };
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && player) { e.preventDefault(); closeFilm(); } });
  /* only the poster of the opening chapter (or a picture that names its film) is the product film; the posters
     »… hjemme hos en kunde« further down are customers' own films and stay as they are until those films are in place */
  const opening = root.querySelector('section');
  const posters = [...root.querySelectorAll('img[data-film-url]')];
  if (opening) opening.querySelectorAll('img[alt^="Film:"]').forEach((img) => { if (!posters.includes(img)) posters.push(img); });
  posters.forEach((img) => {
    const m = (img.getAttribute('data-film-url') || '').match(/(?:v=|youtu\.be\/|embed\/)([\w-]{11})/);
    const yt = m ? m[1] : '';
    const src = root.getAttribute('data-film') || '';
    if (!yt && !src) return;
    const box = img.parentElement;
    const label = (img.alt || 'Film').replace(/^Film:\s*/, 'Film: ');
    const open = () => openFilm(box, label, src, yt, img.currentSrc || img.src);
    box.setAttribute('data-apc-film', '');
    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', 'Spela upp ' + label.charAt(0).toLowerCase() + label.slice(1));
    box.addEventListener('click', open);
    box.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  });

  /* The product film on the opening picture (owner, 3 Oct 2026: »Promo video on each product page«). When the product
     has a film and no picture is a film poster yet, the first picture of the first chapters becomes one, drawn as on
     the Lumina Pro board: play disc bottom left, »Film · 0:57« bottom right. The film is the YouTube film named on the
     wrapper (data-film-yt: products whose gallery only has a short clip), else the film from the gallery.
     Switch: the section setting »Film på det første billede« (data-film-poster). */
  const ytRoot = root.getAttribute('data-film-yt') || '';
  const srcRoot = root.getAttribute('data-film') || '';
  if (root.hasAttribute('data-film-poster') && (ytRoot || srcRoot) && !root.querySelector('[data-apc-film]')) {
    /* the first picture a visitor sees in the first three chapters (a page keeps separate pictures for computers and
       phones: only the one that is shown counts) */
    let box = null;
    for (const s of [...root.querySelectorAll('section')].slice(0, 3)) {
      /* a plain photo only: a picture with numbers or labels drawn on it (a diagram) is not a film poster */
      box = [...s.querySelectorAll('.ib')].find((b) => b.children.length === 1 && b.firstElementChild.tagName === 'IMG' && b.getBoundingClientRect().width >= 200) || null;
      if (box) break;
    }
    if (box) {
      const img = box.querySelector('img');
      const len = ytRoot ? '' : (root.getAttribute('data-film-len') || '');
      const nameEl = document.querySelector('.ap-bar__nm') || document.querySelector('.ap h1');
      const name = nameEl ? nameEl.textContent.trim() : '';
      const disc = document.createElement('span');
      disc.className = 'apc-pd';
      disc.setAttribute('aria-hidden', 'true');
      disc.innerHTML = '<svg viewBox="0 0 22 22" fill="currentColor"><path d="M7 4.5v13l11-6.5z"></path></svg>';
      const tag = document.createElement('span');
      tag.className = 'apc-pt';
      tag.textContent = len ? 'Film · ' + len : 'Film';
      box.append(disc, tag);
      const open = () => openFilm(box, 'Film' + (name ? ': ' + name : ''), srcRoot, ytRoot, img.currentSrc || img.src);
      box.setAttribute('data-apc-film', '');
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.setAttribute('aria-label', 'Spela upp filmen' + (name ? ' om ' + name : '') + (len ? ' (' + len + ')' : ''));
      box.addEventListener('click', open);
      box.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    }
  }

  const MINUS = 'M2 8h12';
  const PLUS = 'M8 2v12M2 8h12';
  root.querySelectorAll('.hrow > .q').forEach((q, i) => {
    const row = q.parentElement;
    /* a one-line summary (.one) always stays; a row with nothing more to show gets no open/close sign */
    const body = [...row.children].filter((el) => el !== q && !el.classList.contains('one'));
    const icon = q.lastElementChild && q.lastElementChild.tagName.toLowerCase() === 'svg' ? q.lastElementChild : null;
    const path = icon && icon.querySelector('path');
    if (!path) return;
    if (!body.length) { icon.remove(); return; }
    const startOpen = (path.getAttribute('d') || '').replace(/\s+/g, '') === MINUS.replace(/\s+/g, '');
    const id = 'apc-a-' + i;
    const wrap = document.createElement('div');
    wrap.id = id;
    body.forEach((el) => { el.hidden = false; wrap.appendChild(el); }); /* closed rows come with hidden answers */
    row.appendChild(wrap);
    q.setAttribute('data-apc-q', '');
    q.setAttribute('role', 'button');
    q.setAttribute('tabindex', '0');
    q.setAttribute('aria-controls', id);
    q.setAttribute('aria-expanded', String(startOpen));
    wrap.hidden = !startOpen;
    const toggle = () => {
      const open = q.getAttribute('aria-expanded') !== 'true';
      q.setAttribute('aria-expanded', String(open));
      wrap.hidden = !open;
      path.setAttribute('d', open ? MINUS : PLUS);
    };
    q.addEventListener('click', toggle);
    q.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });

  /* »Læs alle N anmeldelser« points to #alle-anmeldelser: the review list below the chapters (the review app's section) */
  if (!document.getElementById('alle-anmeldelser')) {
    const reviews = document.querySelector('[id$="__reviews"]');
    if (reviews) {
      const mark = document.createElement('span');
      mark.id = 'alle-anmeldelser';
      reviews.prepend(mark);
    }
  }

  root.querySelectorAll('a[href^="#"]').forEach((a) => {
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    const target = id && document.getElementById(id);
    if (!target) {
      const p = a.closest('p');
      if (p && p.textContent.trim() === a.textContent.trim()) p.hidden = true;
      else a.hidden = true;
      return;
    }
    a.addEventListener('click', () => {
      const det = target.closest('details');
      if (det && !det.open) det.open = true;
    });
  });

  /* »Læs mere« / »Læs alle vilkår«: a button that opens the shortened text it controls (phone layouts) */
  /* Question rows written as <button class="q" aria-controls> (all families but Aspire): first answer of a
     chapter open, the rest closed from the start (canvas note: »På siden: lukket fra start«; owner: first one open) */
  const seenFirst = new Set();
  root.querySelectorAll('.hrow button.q[aria-controls]').forEach((btn) => {
    const target = document.getElementById(btn.getAttribute('aria-controls'));
    const path = btn.querySelector('svg path');
    if (!target) return;
    const sec = btn.closest('section');
    const set = (open) => {
      btn.setAttribute('aria-expanded', String(open));
      target.hidden = !open;
      if (path) path.setAttribute('d', open ? MINUS : PLUS);
    };
    /* the computer and the phone copy of a list each have their own first row */
    const key = (sec ? sec.id : '') + (btn.closest('.ad') ? ':d' : btn.closest('.am') ? ':m' : '');
    set(sec && sec.id === 'faq' ? !seenFirst.has(key) : btn.getAttribute('aria-expanded') === 'true');
    seenFirst.add(key);
    btn.addEventListener('click', () => set(btn.getAttribute('aria-expanded') !== 'true'));
  });

  root.querySelectorAll('button[aria-controls]:not(.q)').forEach((btn) => {
    /* the computer and the phone copy can carry the same id: take the box in the button's own copy */
    const same = [...root.querySelectorAll('[id="' + btn.getAttribute('aria-controls') + '"]')];
    const dev = btn.closest('.ad, .am');
    const live = (t) => { const w = t.closest('.ad, .am'); return !w || getComputedStyle(w).display !== 'none'; };
    const target = same.find((t) => dev && t.closest('.ad, .am') === dev) || same.find(live) || same[0];
    if (!target || !root.contains(target)) return;
    const more = btn.textContent;
    /* a question whose answer is a hidden box (»Kaffeguiden«): open and close it; the label stays */
    if (target.hasAttribute('hidden') || btn.getAttribute('aria-expanded') === 'true') {
      const path = btn.querySelector('svg path');
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        target.hidden = !open;
        if (path) path.setAttribute('d', open ? MINUS : PLUS);
      });
      return;
    }
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      target.classList.toggle('apc-open', open);
      btn.textContent = open ? 'Visa mindre' : more;
    });
  });

  /* The chapter bar: fixed under the header once the top section has passed; marks the chapter in view.
     On phones it shows while scrolling up only (it must not cover the reading). */
  const bar = root.querySelector('[data-apn]');
  if (bar) {
    const headerEl = () => document.querySelector('.header-section') || document.querySelector('#SiteHeader');
    const headerOffset = () => {
      const h = headerEl();
      if (!h) return 0;
      const pos = getComputedStyle(h).position;
      const r = h.getBoundingClientRect();
      return pos === 'fixed' || pos === 'sticky' || r.top >= 0 ? Math.max(0, r.bottom) : 0;
    };
    const nav = bar.querySelector('nav');
    const links = [...nav.querySelectorAll('a[href^="#"]')]
      .map((a) => ({ a, t: document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))) }))
      .filter((l) => { if (!l.t) l.a.remove(); return !!l.t; });
    const top = [...document.querySelectorAll('.ap')].find((s) => !s.classList.contains('apc'));
    const phone = window.matchMedia('(max-width: 989.98px)');
    let lastY = window.scrollY;
    let goingUp = false;
    let current = null;
    const update = () => {
      const off = headerOffset();
      const y = window.scrollY;
      if (y < lastY - 4) goingUp = true; else if (y > lastY + 4) goingUp = false;
      lastY = y;
      const rr = root.getBoundingClientRect();
      const past = top ? top.getBoundingClientRect().bottom < off + 8 : rr.top < off;
      let on = links.length > 1 && past && rr.bottom > off + 160;
      if (phone.matches) on = on && goingUp;
      bar.style.top = Math.round(off) + 'px';
      if (on !== bar.classList.contains('is-on')) {
        bar.classList.toggle('is-on', on);
        bar.toggleAttribute('inert', !on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      const line = off + bar.offsetHeight + 24;
      let cur = null;
      /* a chapter counts from the place an in-page link scrolls it to (its scroll margin) */
      links.forEach((l) => {
        const m = parseFloat(getComputedStyle(l.t).scrollMarginTop) || 0;
        if (l.t.getBoundingClientRect().top <= Math.max(line, m) + 8) cur = l;
      });
      if (cur !== current) {
        if (current) current.a.removeAttribute('aria-current');
        if (cur) {
          cur.a.setAttribute('aria-current', 'location');
          const left = cur.a.offsetLeft - nav.offsetLeft - 16;
          if (nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
        }
        current = cur;
      }
    };
    /* a handful of measurements per scroll event: cheap enough to run directly */
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  const form = document.querySelector('[data-ap-form]');
  const main = form && form.querySelector('[data-ap-add]');
  root.querySelectorAll('[data-apc-add], #kob button.cta').forEach((btn) => {
    if (!form || !main || main.disabled) { btn.hidden = true; return; }
    btn.addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(main); else main.click();
    });
  });
})();
